import NotificationServiceModel from '@/models/NotificationServiceModel';
import doc                      from '@widesk-core/decorators/doc';

@doc.path('/stonecode_notification_subscriptions/subscribe')
export default class SubscribeModel extends NotificationServiceModel {}